export interface IMedication {
  id: number;
  medicineName: string;
  medicineType: string;
  route: string;
  dose: string;
  maxDose?: string;
  indication: string;
  frequency: IFrequency[];
  prescribedby: string;
  scheduled: string;
  dateTime: string;
  vteAssessed: boolean | null;
  prophylaxis: boolean | null;
  contraindicated: boolean | null;
  maxPRN: string;
  frequencyName: string;
  isVariable: boolean;
}

export interface IMedicationHistory {
  id: number;
  medicineName: string;
  medicineType: string;
  dose: string;
  schedule: string;
  startDate: string;
  reason?: string;
  signedBy: string;
  counterSignedBy: string;
  status: any;
  scheduleTimeId: number;
}

export interface IDoseDetails {
  id: number;
  frequencyId: number;
  scheduleTime: string;
  prescribedId: number;
  isGiven: boolean;
  dose: string;
  reason: string;
  signedBy: string;
  counterSignedBy: string;
  updatedOn: string;
  vteAssessed: boolean;
  prophylaxis: boolean;
  contraindicated: boolean;
}

export interface IFrequency {
  schedule: string;
  isGiven: boolean;
  doseDetails: IDoseDetails;
}

export enum IMedicineType {
  "Regular" = "Regular",
  "PRN" = "PRN",
  "Variable" = "Variable",
}

export interface IMedicationLogger {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
  // medicineType: IMedicineType;
  selectedMedication: IMedication;
  selectedFrequency: IFrequency;
  showMedicationAlert: boolean;
  setShowMedicationAlert: React.Dispatch<React.SetStateAction<boolean>>;
  loadData: () => void;
  loadHistory: () => void;
}

export type IMedicationAlert = Pick<
  IMedicationLogger,
  "isOpen" | "setIsOpen" | "setShowMedicationAlert" | "selectedFrequency"
>;

export interface IReason {
  id: number;
  reason: string;
}

export type TimeSlot = {
  label: string;
  start: string;
  end: string;
};
